<template>
  <v-icon
      small
      :color="color ? color : 'grey'"
      class="pencil-hover">
    mdi-pencil
  </v-icon>
</template>

<script>
export default {
  name: 'EditDialogPencil',
  props: ['color'],
}
</script>

<style scoped>
.pencil-hover {
  display: none !important;
  position: absolute;
  margin-left: 2px;
}

.v-small-dialog__activator:hover .pencil-hover {
  display: inline !important;
}
</style>